import { useNavigate } from "@tanstack/react-router";
import { UserInfoContext, UserInfoType } from "context/UserInfoContext";
import useCharacterInput from "hooks/useCharacterInput";
import useNavigationAudio from "hooks/useNavigationAudio";
import useUserInfoNavigation from "hooks/useUserInfoNavigation";
import { useContext, useEffect, useState } from "react";
import { characters } from "utilities/characters";
import QuizLayout from "../Quiz/components/QuizLayout/QuizLayout";
import InputArea from "./components/InputArea/InputArea";
import InputSelect from "./components/InputSelect/InputSelect";

export default function PostCode() {
  const { setUserInfo, userInfo, page, setPage } = useContext(UserInfoContext);
  const navigate = useNavigate();
  const audio = useNavigationAudio();
  const [endQuizModal, setEndQuizModal] = useState(false);

  const {
    currentPosition,
    setCurrentPosition,
    input,
    setInput,
    index,
    setIndex,
  } = useCharacterInput({
    initialInput: userInfo.postcode,
    maxLength: 4,
    initialPosition: 5,
  });

  useEffect(() => {
    setUserInfo({
      postcode: ["", "", "", ""],
      age: ["", ""],
    } as UserInfoType);
    setInput(["", "", "", ""]);
    setCurrentPosition(5);
  }, []);

  const handleNumberInput = (character: number) => {
    setUserInfo((prev: UserInfoType) => {
      const newValue = { ...prev };
      if (newValue.postcode.length === 4 && !newValue.postcode.includes("")) {
        return newValue;
      }
      const newPostcode = [...newValue.postcode];
      newPostcode.splice(index, 1, character.toString());
      newValue.postcode = newPostcode;
      return newValue;
    });
  };

  const handleBackspace = () => {
    setUserInfo((prev: UserInfoType) => {
      const newValue = { ...prev };
      const newPostcode = [...newValue.postcode];
      newPostcode.splice(index - 1, 1, "");
      newValue.postcode = newPostcode;
      return newValue;
    });
  };

  const handleComplete = () => {
    if (userInfo.postcode.length === 4 && !userInfo.postcode.includes("")) {
      if (userInfo.postcode.toString() === "0,1,2,3") {
        navigate({ to: "/questionaire-picker" });
        return;
      }
      setPage(page + 1);
      navigate({ to: "/age" });
    }
  };

  const handleEnter = () => {
    const currentCharacter = characters[currentPosition];

    if (typeof currentCharacter === "number") {
      audio.confirmNumber.play();
      handleNumberInput(currentCharacter);
      setIndex(index + 1);
    } else if (currentCharacter === "back" && index > 0) {
      handleBackspace();
      setIndex(index - 1);
    } else if (currentCharacter === "complete") {
      audio.checkmark.play();
      handleComplete();
    }
  };

  const { backSelected, endQuizSelected, eventCounter } = useUserInfoNavigation(
    {
      audio,
      currentPosition,
      setCurrentPosition,
      onEnter: handleEnter,
      setEndQuizModal,
      canNavigateBack: false,
    },
  );

  return (
    <QuizLayout
      title="Wat zijn de 4 cijfers van je postcode"
      titleAbsolute
      backSelected={backSelected}
      endQuizSelected={endQuizSelected}
      eventCounter={eventCounter}
      questionIndex={page}
      endQuizModal={endQuizModal}
      setEndQuizModal={setEndQuizModal}
    >
      <InputArea input={input} />
      <InputSelect
        options={characters}
        currentPosition={currentPosition}
        numberOfSteps={characters.length}
      />
    </QuizLayout>
  );
}
